export default __webpack_public_path__ + "static/media/roboto-condensed-v19-latin-italic.85b2f981.woff";